/**
 * Google Analytics utility functions
 * Measurement ID: G-0G2PFP11G6
 */

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    dataLayer?: any[];
  }
}

/**
 * Track page views
 */
export const trackPageView = (url: string, title?: string) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('config', 'G-0G2PFP11G6', {
      page_path: url,
      page_title: title,
    });
  }
};

/**
 * Track custom events
 */
export const trackEvent = (
  eventName: string,
  eventParams?: {
    category?: string;
    label?: string;
    value?: number;
    [key: string]: any;
  }
) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', eventName, eventParams);
  }
};

/**
 * Track user actions
 */
export const analytics = {
  // Student actions
  selectProgram: (program: string, semester: string, group: string) => {
    trackEvent('select_program', {
      category: 'Student',
      program,
      semester,
      group,
    });
  },

  viewTimetable: (type: 'personal' | 'browse' | 'exam') => {
    trackEvent('view_timetable', {
      category: 'Timetable',
      timetable_type: type,
    });
  },

  exportPDF: (type: string) => {
    trackEvent('export_pdf', {
      category: 'Export',
      export_type: type,
    });
  },

  // Notification actions
  enableNotifications: () => {
    trackEvent('enable_notifications', {
      category: 'Notifications',
    });
  },

  setReminderTime: (minutes: number) => {
    trackEvent('set_reminder_time', {
      category: 'Notifications',
      reminder_minutes: minutes,
    });
  },

  testNotification: () => {
    trackEvent('test_notification', {
      category: 'Notifications',
    });
  },

  // Navigation
  viewBusSchedule: () => {
    trackEvent('view_bus_schedule', {
      category: 'Navigation',
    });
  },

  viewRoomNavigation: () => {
    trackEvent('view_room_navigation', {
      category: 'Navigation',
    });
  },

  viewAcademicCalendar: () => {
    trackEvent('view_academic_calendar', {
      category: 'Calendar',
    });
  },

  // Settings
  changeTheme: (theme: 'light' | 'dark') => {
    trackEvent('change_theme', {
      category: 'Settings',
      theme,
    });
  },

  // Contact & Feedback
  submitFeedback: (rating?: number) => {
    trackEvent('submit_feedback', {
      category: 'Engagement',
      rating,
    });
  },

  contactSubmit: () => {
    trackEvent('contact_submit', {
      category: 'Engagement',
    });
  },

  // PWA
  installPWA: () => {
    trackEvent('install_pwa', {
      category: 'PWA',
    });
  },

  // Teacher actions
  teacherLogin: () => {
    trackEvent('teacher_login', {
      category: 'Teacher',
    });
  },

  // Admin actions
  adminLogin: () => {
    trackEvent('admin_login', {
      category: 'Admin',
    });
  },

  // Errors
  trackError: (error: string, context?: string) => {
    trackEvent('error', {
      category: 'Error',
      error_message: error,
      error_context: context,
    });
  },
};

export default analytics;
